const DEFAULT_COLUMNS = [
    {
      id: 'DEFAULT_0',
      title: 'FORM',
      selected: true,
      custom: true,
      dataKey: 'order_number',
      sortId: 'order_number',
      formatId: 'noice.log.date'
    },
    {
      id: 'DEFAULT_1',
      title: 'CREATED By',
      selected: true,
      custom: true,
      dataKey: 'created_by',
      sortId: 'created_by',
      formatId: 'asset_registry.table.uid1'
    },
    {
      id: 'DEFAULT_2',
      title: 'DATE',
      selected: true,
      custom: true,
      dataKey: 'created_at',
      sortId: 'created_at',
      formatId: 'noise_log.public.name'
    },
    {
      id: 'DEFAULT_3',
      title: 'FORM NAME',
      selected: true,
      custom: true,
      dataKey: 'title',
      sortId: 'title',
      formatId: 'noise_log.public.last_name'
    },
    {
      id: 'DEFAULT_4',
      title: 'FORM CETEGORY',
      selected: true,
      custom: true,
      dataKey: 'category',
      sortId: 'category',
      formatId: 'hazard.new.phone'
    },
    {
      id: 'DEFAULT_5',
      title: 'WEATHER CONDITIONS',
      selected: true,
      custom: true,
      dataKey: 'weather_conditions',
      sortId: 'weather_conditions',
      formatId: 'noice.log.status'
    }
  ];
  export default DEFAULT_COLUMNS;
